



















import { Component, Mixins } from 'vue-property-decorator';
import { VButton, VInput } from '@/components';
import { ValidationMixin } from '@/mixins';
import { PathName } from '@/utils/enums';
import Authentication from '@/utils/Authentication';
import router from '@/router';

@Component({
  components: {
    VButton,
    VInput
  }
})
export default class OnboardingFamilyMembers extends Mixins(ValidationMixin) {
  email = '';

  goToSigIn() {
    router.safePush!(PathName.SignIn);
  }

  goToConfirmationPage() {
    router.safePush!({ path: PathName.EmailSentScreen, params: { email: this.email } });
  }

  async sendPasswordReset() {
    try {
      await Authentication.instance.sendPasswordReset(this.email);
      return this.goToConfirmationPage();
    } catch (error) {
      console.log(`Send password reset error: ${error.code}`);
      this.displayError(error);
    }
  }
}
